import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console but don't show to user
    console.warn('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Reset after a short delay
      setTimeout(() => {
        this.setState({ hasError: false });
      }, 100);
      
      // Return null to show nothing during error state
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;